<template>
  <div class="offer_box flex-box column">
    <div class="img-box">
      <div class="offer-overlay"></div>

      <picture v-if="_.get(offer, 'images')">
        <source
          media="(max-width: 767px)"
          :srcset="_.get(offer, 'images[0].devices.mobile')"
        />
        <source
          media="(max-width: 1023px)"
          :srcset="_.get(offer, 'images[0].devices.tablet')"
        />
        <img
          :src="_.get(offer, 'images[0].devices.desktop')"
          class="offer_img img-absolute"
          loading="lazy"
          alt
        />
      </picture>

      <div
        v-if="offer.discount"
        class="discount_label flex-box al-center justify-center tbc-bold font-24"
      >
        {{ offer.discount }}
      </div>
    </div>
    <div class="offer_content">
      <h3 class="offer_ttl tbc-bold font-18 text-overflow--line2">
        {{ offer.title }}
      </h3>
      <div
        class="offer_teaser tbc-regular lh-24"
        v-html="_.get(offer, 'teaser')"
        v-if="_.get(offer, 'teaser')"
      ></div>
    </div>

    <a
      v-if="
        _.get(contentData, 'conf.contentType') === 'banner' && offer.moreLinkUrl
      "
      :href="offer.moreLinkUrl"
      class="offer-btn flex-box al-center"
    >
    </a>
    <router-link
      v-else
      :to="$store.getters['main/getSingleUrl'](offer)"
      class="offer-btn flex-box al-center"
    >
    </router-link>
  </div>
</template>

<script>
export default {
  props: ["contentData", "offer"]
};
</script>

<style>
.offer_box {
  position: relative;
  border: 1px solid #364756;
  border-radius: 5px;
  height: 100%;
  background: var(--dark);
}

.offer_box .img-box {
  display: block;
  padding-top: 66.43%;
  overflow: hidden;
  cursor: pointer;
  backface-visibility: hidden;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}
.offer_box .offer_img {
  opacity: 0.9;
  transition: 0.8s ease;
  backface-visibility: hidden;
  /* will-change: transform; */
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}
.offer-overlay {
  background: rgb(0, 0, 0);
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.65) 0%,
    rgba(0, 0, 0, 0) 100%
  );
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 120px;
  z-index: 9;
}
.offer_content {
  height: 100%;
  padding: 34px;
  padding-bottom: 45px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  transition: 0.6s;
}
.discount_label {
  position: absolute;
  bottom: 30px;
  left: 34px;
  z-index: 9;
  color: var(--tbc-blue);
  width: auto;
  white-space: nowrap;
  line-height: 30px;
}

.offer_ttl {
  margin-bottom: 18px;
  transition: 0.6s;
  height: 45px;
}
.offer_teaser {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  transition: 0.6s;
}
.offer-btn {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  cursor: pointer;
}

@media (min-width: 1025px) {
  .offer_box:hover .offer_img {
    transform: scale(1.05);
  }
  .offer_box:hover .offer_content {
    background: #00a3e0;
  }
  .offer_box:hover .offer_ttl,
  .offer_box:hover .offer_teaser {
    color: #1d2934;
  }
}
@media (max-width: 1399px) {
  .offer_content {
    padding: 30px;
  }
  .offers_slider-container .swiper-wrapper {
    padding-bottom: 55px;
  }
}
@media (max-width: 1023px) {
  .offer_content {
    padding: 20px;
  }
  .offer_ttl {
    margin-bottom: 10px;
  }
  .offer_ttl.font-18 {
    font-size: 16px;
  }
}
@media (max-width: 767px) {
  .discount_label {
    left: 15px;
    white-space: inherit;
  }
}
</style>
